import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import FamilyPractice from "./pages/FamilyPractice";
import Pharmacy from "./pages/Pharmacy";
import RehabServices from "./pages/RehabServices";
import Physiotherapy from "./pages/Physiotherapy";
import Chiropractic from "./pages/Chiropractic";
import MassageTherapy from "./pages/MassageTherapy";
import CustomOrthotics from "./pages/CustomOrthotics";
import Team from "./pages/Team";
import Book from "./pages/Book";
import Contact from "./pages/Contact";
import ForPatients from "./pages/ForPatients";
import AfterHours from "./pages/AfterHours";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/family-practice" element={<FamilyPractice />} />
          <Route path="/pharmacy" element={<Pharmacy />} />
          <Route path="/rehab-services" element={<RehabServices />} />
          <Route path="/physiotherapy" element={<Physiotherapy />} />
          <Route path="/chiropractic" element={<Chiropractic />} />
          <Route path="/massage-therapy" element={<MassageTherapy />} />
          <Route path="/custom-orthotics" element={<CustomOrthotics />} />
          <Route path="/team" element={<Team />} />
          <Route path="/for-patients" element={<ForPatients />} />
          <Route path="/after-hours" element={<AfterHours />} />
          <Route path="/book" element={<Book />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
